import appConstants from '../../../../../../../appConstants';
import StopDetailsTitle from '../../../DriverPopUp/common/StopDetailsTitle';
import Label from '../../common/Label';
import DeliveryStatusBadge from '../../DeliveryStatusBadge';
import StopDetails from '../../StopDetails';
import ReturnDetails from '../../ReturnDetails';
import OSNDDetails from '../../OSNDDetails';
import DriverDetails from '../../DriverDetails';
import ShipperDetails from '../../ShipperDetails';
import ShipmentDetails from '../../ShipmentDetails';
import ShipmentInfo from '../../ShipmentInfo';
import Accessorial from '../../Accessorial';
import ExcessiveLength from '../../ExcessiveLength';
import ShrinkWrap from '../../ShrinkWrap';
import ReceiverDetails from '../../ReceiverDetails';
import HazmatDetails from '../../HazmatDetails';
import { Divider } from '@material-ui/core';

const ProDetails = ({
  classes,
  proDetails,
  deliveryStatusList,
  freightBillDetailsApi,
  freightBillDetailsQueryParams,
  DispatchStore,
  enableReturnExceptionReasonLabels
}) => {
  const { proData, stopData, driverData } = proDetails ?? {};
  return (
    <>
      <StopDetailsTitle 
        stopData={stopData}
        isUnattendedDelivery={proData.isUnattendedDelivery}
        enableCustomerLink
        showCustomerCode 
      />
      <div className={classes.delStatusContainer}>
        <div className={classes.deliveryStatusLabel}>
          <Label labelText="Delivery Status" />
        </div>
        <DeliveryStatusBadge
          isCompleted={stopData.isStopCompleted}
          deliveryStatusList={deliveryStatusList}
          proData={proData}
          DispatchStore={DispatchStore}
          enableReturnExceptionReasonLabels={enableReturnExceptionReasonLabels}
        />
      </div>
      {stopData.isStopCompleted && <StopDetails stopData={stopData} />}
      {proData.deliveryCode === appConstants.DELIVERY_CODE.RTN && (
        <>
          <Divider className={classes.divider} />
          <ReturnDetails returnDetail={proData.returnDetail} />
        </>
      )}
      {proData?.deliveryCode === appConstants.DELIVERY_CODE.DE &&
        DispatchStore.staticClientData &&
        proData?.exceptionDetail && (
          <>
            <Divider className={classes.divider} />
            <OSNDDetails
              exceptionDetail={proData.exceptionDetail}
              exceptionList={DispatchStore.exceptions}
            />
          </>
        )}
      <Divider className={classes.divider} />
      <DriverDetails driverData={driverData} />
      <Divider className={classes.divider} />
      <ShipmentDetails
        proData={proData}
        isCompleted={stopData.isStopCompleted}
        packageCode={proData.exceptionDetail?.packageType || proData.returnDetail?.packageType}
      />
      <Divider className={classes.divider} />
      {proData.hazmatInfo?.length > 0 && (
        <>
          <HazmatDetails hazmatInfo={proData.hazmatInfo} />
          <Divider className={classes.divider} />
        </>
      )}
      <ShipperDetails proData={proData} />
      <Divider className={classes.divider} />
      <ShipmentInfo
        shipmentId={proData.shipmentId}
        freightBillDetailsApi={freightBillDetailsApi}
        freightBillDetailsQueryParams={freightBillDetailsQueryParams}
      />
      {stopData.isStopCompleted && DispatchStore.staticClientData && (
        <>
          {proData.accessorials?.length > 0 && DispatchStore.staticClientData && (
            <Accessorial
              accessorialList={DispatchStore.deliveryAccessorials}
              selectedAccessorials={proData.accessorials}
              limitedAccessList={DispatchStore.limitedAccessList}
              selectedLimitedAccessCode={proData.limitedAccessCode}
            />
          )}
          <Divider className={classes.divider} />
          <ExcessiveLength
            excessiveLength={proData.excessiveLength}
            excessiveLengthFeet={proData.excessiveLengthValue}
            excessiveLengthInches={proData.excessiveLengthInches}
          />
          <Divider className={classes.divider} />
          <ShrinkWrap isShrinkWrap={proData.isShrinkWrap} palletCount={proData.palletCount} />
          <Divider className={classes.divider} />
          <ReceiverDetails proData={proData} />
        </>
      )}
    </>
  );
};

export default ProDetails;
